import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DOCUMENT_FORMAT,
  DOCUMENT_STATE,
  DOC_TYPES,
  DocumentModalResultForm,
  RequestDocumentTypes,
} from 'src/app/product-capture/model/consts/document-modal.consts';
import { LANGUAGE_LIST } from 'src/app/product-capture/model/consts/language-list.const';
import { LANGUAGE } from 'src/app/product-capture/model/enums/language.enum';
import { DropDownOption } from 'src/app/product-capture/model/interfaces/drop-down-option.interface';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { ClientUtils } from 'src/app/utils/client.utils';
import { ClientProductDocumentLanguages, DocumentLanguages, ProductDocumentLanguages } from './request-modal.consts';

@Component({
  selector: 'app-request-modal',
  templateUrl: './request-modal.component.html',
  styleUrls: ['./request-modal.component.scss'],
})
export class RequestModalComponent implements OnInit {

  form: FormGroup<DocumentModalResultForm>;

  languages: DropDownOption[] = [];

  documentFormat = DOCUMENT_FORMAT;

  docTypes = DOC_TYPES;

  props: any;

  documentStateItems = DOCUMENT_STATE;

  isTMG = false;

  tenantId: string;

  constructor(
    public modal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private dcAlertService: DcAlertService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      language: [null, Validators.required],
      documentState: [DOCUMENT_STATE[1].id],
      docFormat: ['pdf'],
    });

    this.setupLanguages();
    this.setupTypeControl();
  }

  setupLanguages(): void {
    const { docType, productType } = this.props;

    const client = ClientUtils.getClientFromHostname();

    if (!client) {
      this.languages = [{ id: LANGUAGE.EN, displayValue: 'English' }];
      return;
    }

    const clientDocumentTypes: ProductDocumentLanguages = ClientProductDocumentLanguages[client];
    const documentTypes: DocumentLanguages = clientDocumentTypes?.[productType];

    const languages: LANGUAGE[] = documentTypes?.[docType] ?? [LANGUAGE.EN];

    this.languages = LANGUAGE_LIST.filter(({ id }) => languages.includes(id));
  }

  cancel(): void {
    this.modal.close('cancel');
  }

  save(): void {
    if (this.form.valid) {
      const { type } = this.form.value;
      this.modal.close(this.isTMG ? {
        type: 'OTHER',
        subtype: type,
        language: 'EN',
        documentState: 'FINAL',
      } : this.form.value)
    } else {
      this.dcAlertService.showAlert({
        type: 'danger',
        message: `All fields are required.`,
      });
    }
    this.modal.close('save');
  }

  setupTypeControl(): void {
    if (this.props?.docType !== 'OTHER') {
      return;
    }

    const typeControl = this.fb.control(DOC_TYPES[0].id, Validators.required);
    this.form.addControl('type', typeControl);

    typeControl
    .valueChanges
    .pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((type: RequestDocumentTypes) => {
      this.isTMG = type === RequestDocumentTypes.TMG;

      this.resetLanguageControl();
    });
  }

  resetLanguageControl(): void {
    const language = this.form.get('language');

    language.setErrors(null)
    language.setValidators(!this.isTMG ? Validators.required : Validators.nullValidator);
    language.updateValueAndValidity();
  }

}
